/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Refresh_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to refresh folders" |
*
* @param {Explorer_Nav_Refresh_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_refresh_failed_toast = /** @type {((inputs?: Explorer_Nav_Refresh_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Refresh_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de l'actualisation des dossiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner konnten nicht aktualisiert werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile aggiornare le cartelle")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось обновить папки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron actualizar las carpetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新文件夹失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダを更新できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ोल्डर रीफ़्रेश करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao atualizar as pastas")
	return /** @type {LocalizedString} */ ("Failed to refresh folders")
});